import APIService from '@/services/APIService.js';

export default {
  getCalculosByStatus(status) {
    return APIService.apiCall().get(`/calculoComCaAneel/getCalculosByStatus/${status}`);
  }
};
